import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as site from 'services/site/selectors'
import { Button } from 'components/util'

import styles from 'components/samsung_gear_connect/_samsung_gear_connect.css'
import appImg from 'images/samsung_gear_connect/img-app.png'
import appImg2x from 'images/samsung_gear_connect/img-app@2x.png'
import appImg3x from 'images/samsung_gear_connect/img-app@3x.png'
import gearImg from 'images/samsung_gear_connect/img-gear.png'
import gearImg2x from 'images/samsung_gear_connect/img-gear@2x.png'
import gearImg3x from 'images/samsung_gear_connect/img-gear@3x.png'
import logommr from 'images/samsung_gear_connect/logo-mmr.png'
import oneImg from 'images/samsung_gear_connect/1.png'
import twoImg from 'images/samsung_gear_connect/2.png'

const mapStateToProps = (state, ownProps) => ({
  dev: site.selectDev(state),
  user: state.user,
  stashedid: ownProps.params.stashedid,
})

const mapDispatchToActions = {
}

export class SamsungGearConnect extends Component {

  static propTypes = {
    stashedid: PropTypes.string,
    dev: PropTypes.bool,
    user: PropTypes.object,
  }

  state = {
    isActive: false,
  }

  componentWillMount () {
    window.addEventListener('onfocus', this.handleFocus.bind(this))
    window.addEventListener('onblur', this.handleBlur.bind(this))

    setInterval(() => {
      this.state.isActive ? this.checkAppInstalled().call(this) : null
    }, 1000)
  }

  componentWillUnmount () {
    window.removeEventListener('onfocus', this.handleFocus)
    window.removeEventListener('onblur', this.handleBlur)
  }

  handleFocus () {
    this.setState({
      isActive: true,
    })
  }

  handleBlur () {
    this.setState({
      isActive: false,
    })
  }

  checkAppInstalled () {
    window.location = `mmapps://samsung_gear_connect/${this.props.stashedid}`
  }

  handleDownload = () => {
    window.location = 'https://itunes.apple.com/us/app/map-my-run-gps-running-workout-tracker/id291890420?mt=8'
  }

  render () {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.iconWrapper}><img src={logommr} className={styles.MMRIcon} /></div>
          <div className={styles.connectHeader}>
            How to pair your Samsung Gear:
          </div>
        </div>
        <div className={styles.infoBox}>
          <div><img src={appImg} srcSet={`${appImg2x} 2x, ${appImg3x} 3x,`} /></div>
          <img src={oneImg} className={styles.numberIcon} />
          <div>Download MapMyRun and log-in or create a new account.</div>
        </div>
        <div className={styles.infoBox}>
          <div><img src={gearImg} srcSet={`${gearImg2x} 2x, ${gearImg3x} 3x,`} /></div>
          <img src={twoImg} className={styles.numberIcon} />
          <div>Tap “Retry” on your Gear, or return to this page.</div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            el='button'
            type='mmr'
            className={styles.button}
            onClick={this.handleDownload}
          >
          Download Now
          </Button>
        </div>
      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(SamsungGearConnect)



// WEBPACK FOOTER //
// ./src/components/samsung_gear_connect/samsung_gear_connect.jsx